import { create } from 'zustand';

// Session-scoped token: centre login returns it in the body, with no refresh-cookie flow — so a
// closed tab ends the session. Prefix keeps it clear of the other portals in the same browser.
const TOKEN = 'ic_token';
const NAME = 'ic_name';

interface AuthState {
  token: string | null;
  name: string | null;
  isAuthenticated: boolean;
  setSession: (token: string, name: string) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  token: sessionStorage.getItem(TOKEN),
  name: sessionStorage.getItem(NAME),
  isAuthenticated: !!sessionStorage.getItem(TOKEN),
  setSession: (token, name) => {
    sessionStorage.setItem(TOKEN, token);
    sessionStorage.setItem(NAME, name);
    set({ token, name, isAuthenticated: true });
  },
  logout: () => {
    sessionStorage.removeItem(TOKEN);
    sessionStorage.removeItem(NAME);
    set({ token: null, name: null, isAuthenticated: false });
  },
}));
